import {disconnectAndClearState} from './services/pairingService.js';
import {connectToUSB} from './services/usb.js';
import {connectToBLE} from './services/ble.js';
import {connectToIoT, subscribeToSocketsAndWaitConnected} from './services/iot/iotConnectionService.js';
import {getIotDeviceData, updateUamTokenData} from './services/iot/iotService.js';
import {getIotFwuAvailability, startIotFwu} from './services/iot/iotFwuService.js';
import {autoClean, findMyDevice, resetMyDevice, updateDeviceSetting} from './services/iot/iotSettingsService.js';
import {
    initHolder,
    subscribeOnConnectionState,
    subscribeOnDataChange,
    subscribeOnHolderConnectedState,
    subscribeOnWebSocketDisconnect,
} from './services/device/connectionService.js';
import {init as initLogger} from './services/log.js';
import {init as initUserAgent} from './services/user/userAgentService.js';
import {MW_ERRORS} from './consts/app/mwErrors.js';
import deviceConnectionStatusTypes from './consts/device/deviceConnectionStatusTypes.js';

export const init = (config) => {
    initLogger(config.log);
    initUserAgent(config.userAgent);
};

export {
    initHolder,
    connectToBLE,
    connectToUSB,
    connectToIoT,
    getIotDeviceData,
    subscribeOnDataChange,
    subscribeOnConnectionState,
    subscribeOnHolderConnectedState,
    subscribeOnWebSocketDisconnect,
    updateDeviceSetting,
    updateUamTokenData,
    resetMyDevice,
    findMyDevice,
    autoClean,
    MW_ERRORS,
    deviceConnectionStatusTypes,
    disconnectAndClearState,
    getIotFwuAvailability,
    startIotFwu,
    subscribeToSocketsAndWaitConnected,
};
